import React from "react";
import ReactExport from "react-export-excel";
import { Button } from "@material-ui/core";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

//NOTE:- this component export the searchData to an excel file when we click on the "Export order Data to excel"

const ExportData = ({ callDataTable, searchData }) => {
  
  return (
    <ExcelFile
      filename={"vEngage-Call Stats"}
      element={
        <Button variant="contained" color="primary">
          Export Order Data To Excel
        </Button>
      }
      >
      <ExcelSheet data={searchData} name="CallData">
        <ExcelColumn label="Call Date/Time" value="initiate_time" />
        <ExcelColumn label="Caller ID" value="caller_id" />
        <ExcelColumn label="Caller ID Anonymized" value="caller_id_anonymized" />
        <ExcelColumn label="Customer Name" value="customer_name" />
        <ExcelColumn label="Center Name" value="center_name" />
        <ExcelColumn label="Center ID" value="center_id" />
        <ExcelColumn label="Call Source" value="initiator_source" />
        <ExcelColumn label="Call Status" value="call_status" />
        <ExcelColumn
          label="Status Code"
          value="operator_feedback"
        />
        <ExcelColumn
          label="Status Code Description"
          value="operator_feedback_english"
        />
        <ExcelColumn label="F Name" value="first_name" />
        <ExcelColumn label="F Name Anonymized" value="first_name_anonymized" />
        <ExcelColumn label="L Name" value="last_name" />
        <ExcelColumn label="L Name Anonymized" value="last_name_anonymized" />        
        <ExcelColumn label="Caller No" value="mobile_number" />
        <ExcelColumn label="Caller No Anonymized" value="mobile_number_anonymized" />
        <ExcelColumn label="Appointment Date/Time" value="schedule_datetime" />
        <ExcelColumn label="Requested Service" value="scan_description" />
        <ExcelColumn label="Modality" value="modality_generic" />
        <ExcelColumn label="Tags" value="conversation_tags" />
        <ExcelColumn label="Operator Name" value="operator_id" />
        <ExcelColumn label="Operator Feedback" value="feedback" />
        <ExcelColumn label="SMS TAT(seconds)" value="sms_tat" />
        <ExcelColumn label="Conversation Duration (seconds)" value="conversation_duration" />
        <ExcelColumn label="Current state" value="current_state" />
        <ExcelColumn label="Current internal state" value="current_internal_state" />
        <ExcelColumn label="Conversation workflow" value="conversation_workflow_type" />
        <ExcelColumn label="Conversation context" value="conversation_context" />
        <ExcelColumn label="Conversation ID" value="conversation_id" />
        
        {/* <ExcelColumn label="Caller ID" value="caller_id" /> */}
        
        
        {/* <ExcelColumn label="Stop Point" value="observation_from_chat" /> */}
        {/* <ExcelColumn label="Additional Remarks" value="additional_remark" /> */}
      </ExcelSheet>
    </ExcelFile>
  );
};

export default ExportData;
